import type * as Types from '../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type VideoAssetsStatusQueryVariables = Types.Exact<{
  ids: Array<Types.Scalars['ID']> | Types.Scalars['ID'];
}>;

export type VideoAssetsStatusQuery = {
  __typename?: 'Query';
  videoAssets: Array<{
    __typename?: 'VideoAsset';
    id: string;
    url: string;
    thumbnailUrl?: string | null;
    mimeType: string;
    deleted: boolean;
    status: Types.VideoAssetStatus;
  } | null>;
};

export const VideoAssetsStatusDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'VideoAssetsStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
          type: { kind: 'NonNullType', type: { kind: 'ListType', type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videoAssets' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'ids' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AdminVideoAssetFields' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AdminVideoAssetFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'VideoAsset' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deleted' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useVideoAssetsStatusQuery__
 *
 * To run a query within a React component, call `useVideoAssetsStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideoAssetsStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideoAssetsStatusQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useVideoAssetsStatusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<VideoAssetsStatusQuery, VideoAssetsStatusQueryVariables>) {
  return ApolloReactHooks.useQuery<VideoAssetsStatusQuery, VideoAssetsStatusQueryVariables>(VideoAssetsStatusDocument, baseOptions);
}
export function useVideoAssetsStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<VideoAssetsStatusQuery, VideoAssetsStatusQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<VideoAssetsStatusQuery, VideoAssetsStatusQueryVariables>(VideoAssetsStatusDocument, baseOptions);
}
export type VideoAssetsStatusQueryHookResult = ReturnType<typeof useVideoAssetsStatusQuery>;
export type VideoAssetsStatusLazyQueryHookResult = ReturnType<typeof useVideoAssetsStatusLazyQuery>;
export type VideoAssetsStatusQueryResult = Apollo.QueryResult<VideoAssetsStatusQuery, VideoAssetsStatusQueryVariables>;
